module.exports = __webpack_public_path__ + "assets/addthis.6d449438.svg";